const stoppers = new Set();

export function registerKmsTaskStopper(fn) {
    stoppers.add(fn);
    return () => stoppers.delete(fn);
}

/**
 * 激活码被其他设备占用、会话失效时：停止抢购/上架/资产后台任务等，并结束前台服务通知。
 * 不静态 import purchase.js / background.js，避免与 appSecurity、capacitor-vendor 循环依赖（生产构建 TDZ）。
 */
export function stopAllKmsBoundTasks() {
    void import("@/services/purchase").then((m) => {
        try {
            m.stopPurchase?.();
        }
        catch (e) {
        }
    }).catch(() => {
    });
    for (const fn of stoppers) {
        try {
            fn();
        }
        catch (e) {
        }
    }
    void import("@/utils/background").then((m) => {
        try {
            m.stopBgService?.();
        }
        catch (e) {
        }
    }).catch(() => {
    });
}
